import traverseThreeObject from './traverseThreeObject';

export const disposeThreeObject = (object) => {
	if (!object) return;
	traverseThreeObject(object, (child) => {
		if (child.geometry) child.geometry.dispose();
		if (!child.material) return undefined;
		if (!child.material.length) return child.material.dispose();
		return child.material.forEach((material) => material.dispose());
	});
};

export default disposeThreeObject;
